export default function Gallery() {
  const photos = [
    {
      alt: "Poignée de fenêtre cassée en gros plan à Strasbourg",
      prompt: "A close-up of a broken white plastic window handle on a modern uPVC window, the handle is cracked and hanging loose, showing the damaged mechanism inside the window frame, warm natural lighting inside a French home, clean interior, professional repair context, photorealistic, soft warm tones",
      w: 600,
      h: 400,
      seq: "pg1",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/52f805284ab9f255153655db602f45fe.jpeg",
      label: "Poignée de fenêtre cassée en gros plan à Strasbourg",
    },
    {
      alt: "Technicien remplaçant une poignée de fenêtre à Schiltigheim, Bas-Rhin",
      prompt: "A professional technician replacing a window handle on a modern French home window, close-up on hands and the new handle being installed, warm natural lighting, clean interior background, professional repair service, photorealistic, soft warm tones",
      w: 600,
      h: 400,
      seq: "pg2",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/e8838c6c034fe2f6e3242931acf07e01.jpeg",
      label: "Technicien remplaçant une poignée de fenêtre à Schiltigheim, Bas-Rhin",
    },
    {
      alt: "Carré d'entraînement usé et poignée démontée à Haguenau",
      prompt: "A close-up of a disassembled window handle mechanism showing the worn square drive spindle and the broken handle on a white table, the metal parts are slightly rusted, bright natural lighting, clean modern workshop, professional repair context, photorealistic, warm tones",
      w: 600,
      h: 400,
      seq: "pg3",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/1a8fbabb4d01d000753c93a61c4b3baf.jpeg",
      label: "Carré d'entraînement usé et poignée démontée à Haguenau",
    },
    {
      alt: "Crémone et poignée compatibles sur une fenêtre à Strasbourg",
      prompt: "Close-up of a newly installed window handle and cremone bar on a modern white uPVC window, the handle is sleek and modern, the mechanism is perfectly aligned, bright natural lighting inside a French home, clean interior, professional repair finish, photorealistic, warm tones",
      w: 600,
      h: 400,
      seq: "pg4",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/4f5ebbcb84a72fdd78cd48d354b38b1d.webp",
      label: "Crémone et poignée compatibles sur une fenêtre à Strasbourg",
    },
    {
      alt: "Technicien DF PRO vérifiant le fonctionnement après remplacement à Illkirch",
      prompt: "A professional technician testing a newly replaced window handle by turning it smoothly, the window is in a bright French home interior, warm natural lighting, clean interior, the technician is smiling satisfied, professional repair service, photorealistic, soft warm tones",
      w: 600,
      h: 400,
      seq: "pg5",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/3e2fe7d9885f0567bad4555622dccaef.jpeg",
      label: "Technicien DF PRO vérifiant le fonctionnement après remplacement à Illkirch",
    },
    {
      alt: "Poignée de fenêtre neuve et fonctionnelle dans le Bas-Rhin",
      prompt: "A beautiful modern window handle on a white uPVC window in a bright French home living room, the handle is pristine and elegant, the window is slightly open showing the smooth mechanism, warm natural lighting, cozy interior, photorealistic, soft warm tones, professional finish",
      w: 600,
      h: 400,
      seq: "pg6",
      src: "https://static.readdy.ai/image/60b7a1bdc124301cce40c5bb19c672c9/6d237f782373e8b9b4c897af9248880c.webp",
      label: "Poignée de fenêtre neuve et fonctionnelle dans le Bas-Rhin",
    },
  ];

  return (
    <section className="bg-white py-10 md:py-14 lg:py-16">
      <div className="w-full px-4 md:px-8 lg:px-12 max-w-[1280px] mx-auto">
        <div className="mb-10 md:mb-14">
          <p className="font-serif italic text-plum-dark text-sm md:text-base mb-3">
            Galerie de réalisations
          </p>
          <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-plum">
            Nos <span className="font-serif italic">interventions</span> sur poignée
          </h2>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6">
          {photos.map((p) => (
            <div key={p.seq} className="rounded-2xl overflow-hidden border border-rose-200 bg-rose-50">
              <img
                src={p.src || `https://readdy.ai/api/search-image?query=${encodeURIComponent(p.prompt)}&width=${p.w}&height=${p.h}&seq=${p.seq}&orientation=landscape`}
                alt={p.alt}
                className="w-full h-[260px] object-cover object-top"
              />
              <div className="px-4 py-3">
                <p className="text-xs text-plum-dark/60 italic">{p.label || "[PHOTO]"}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}